export default function Hero({ profile }) {
  const heroImg =
    "https://customer-assets.emergentagent.com/job_journalism-showcase/artifacts/1kckm5sx_79027446_10218477390103186_8846702533117214720_n.jpg";

  return (
    <section
      id="work"
      data-testid="hero-section"
      className="relative w-full min-h-[100svh] flex flex-col justify-end overflow-hidden bg-[#0D0D0D]"
    >
      <div className="absolute inset-0">
        <img
          src={heroImg}
          alt="Documentary filmmaking on location"
          className="w-full h-full object-cover"
          loading="eager"
        />
        <div className="absolute inset-0 hero-vignette" />
        <div className="absolute inset-0 grain" />
      </div>

      {/* Vertical edge label — magazine spine feel */}
      <div className="hidden lg:flex absolute top-1/2 right-4 -translate-y-1/2 rotate-90 origin-right z-20 items-center gap-3">
        <span className="font-mono-overline text-[#EAEAEA]/60 tracking-[0.4em]">
          Est. 2026 · Portfolio · Vol. I
        </span>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pb-12 md:pb-20 pt-28 w-full">
        <div className="flex items-center gap-3 mb-6 reveal in">
          <span className="w-10 h-px bg-[#C4A27A]" />
          <span data-testid="hero-tagline" className="font-mono-overline text-[#C4A27A]">
            {profile?.tagline || "Multimedia journalist · Documentary filmmaker"}
          </span>
        </div>

        <h1
          data-testid="hero-name"
          className="display-xl text-[#EAEAEA] text-5xl sm:text-7xl md:text-8xl lg:text-[8.5rem] reveal in"
        >
          {profile?.name || "Nadeer Hashmi"}
        </h1>

        <p className="max-w-2xl mt-8 text-[#EAEAEA]/85 text-base md:text-lg leading-relaxed reveal in" data-testid="hero-bio-short">
          {profile?.bio_short ||
            "Reporter at CBC News covering rural Canada with field-driven, character-led storytelling."}
        </p>

        <div className="mt-5 flex items-center gap-3 reveal in">
          <span className="font-mono-overline text-[#EAEAEA]/45 text-[10px]">
            Bylines · CBC News · CBC North · NFMLA &apos;20
          </span>
        </div>

        <div className="mt-6 flex flex-wrap items-center gap-4 reveal in">
          <button
            data-testid="hero-cta-work"
            onClick={() =>
              document.getElementById("documentaries")?.scrollIntoView({ behavior: "smooth" })
            }
            className="btn-ghost text-[#EAEAEA]"
          >
            See the work
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
          </button>
          <button
            data-testid="hero-cta-contact"
            onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
            className="font-mono-overline text-[#EAEAEA]/80 hover:text-[#C4A27A] transition-colors pb-1 border-b border-white/30 hover:border-[#C4A27A]"
          >
            Get in touch
          </button>
        </div>

        <div className="mt-10 flex items-center gap-8 text-[#EAEAEA]/60 reveal in">
          <div>
            <div className="font-mono-overline mb-1">Based</div>
            <div className="font-serif-display text-xl text-[#EAEAEA]" data-testid="hero-location">
              {profile?.location || "Red Deer, Alberta"}
            </div>
          </div>
          <div className="w-px h-10 bg-white/15" />
          <div>
            <div className="font-mono-overline mb-1">Currently</div>
            <div className="font-serif-display text-xl text-[#EAEAEA]">CBC News</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 right-6 md:right-12 z-10 flex items-center gap-2 text-[#EAEAEA]/60">
        <span className="font-mono-overline">Scroll</span>
        <span className="w-12 h-px bg-[#EAEAEA]/40" />
      </div>
    </section>
  );
}
